export enum AppThemeEnum {
  LIGHT = "THEME_LIGHT",
  DARK = "THEME_DARK",
}
